import { debounce } from "lodash-es"

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
  const togglefiltersButtonLink: HTMLAnchorElement | null = document.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__toggle-filters-button-link');
  const formCheckInputs: NodeListOf<HTMLInputElement> = block.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters__form-check-input');
  const formWrapperElement: HTMLDivElement | null = block.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__form-wrapper');
  const formElement: HTMLFormElement | null = block.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__form');
  const productContainer: HTMLElement | null = document.getElementById('product-filters-products-container');
  let abortController: AbortController | null = null;

  function reloadProductsWithUrl(url, shoudScrollContainerIntoView = false) {
    if (! productContainer) {
      return;
    }

    productContainer.classList.add('is-loading');

    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();

    fetch(url, {
      method: 'get',
      signal: abortController.signal,
    })
    .then((response: Response) => response.text())
    .then((body: string) => {
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(body, 'text/html');
      const wpBlockQueryHtml: HTMLElement | null = responseDoc.getElementById('product-filters-products-container');

      if (!wpBlockQueryHtml) {
        return;
      }

      productContainer.innerHTML = wpBlockQueryHtml.innerHTML;

      responseDoc.querySelectorAll<HTMLLabelElement>('label.wp-block-byggma-brann-og-lyd-product-filters__label')
        .forEach((labelElement) => {
          const docCountEl = document
            .querySelector(`label.wp-block-byggma-brann-og-lyd-product-filters__label[for="${labelElement.htmlFor}"] .wp-block-byggma-brann-og-lyd-product-filters__count`)

          if (!docCountEl) {
            return;
          }

          const count = labelElement.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__count')?.innerHTML
          docCountEl.innerHTML = count ? count : '';
        })
      if (
        shoudScrollContainerIntoView
        && productContainer.getBoundingClientRect().top < 0
      ) {
        productContainer.scrollIntoView({behavior:'smooth'});
      }
    })
    .catch((err) => {
      console.error(`Fetch error: ${err.message}`);
    })
    .finally(() => {
      productContainer.classList.remove('is-loading');

      window.history.replaceState({}, "", url);
    });;
  }

  document.querySelectorAll<HTMLDivElement>('.wp-block-byggma-brann-og-lyd-product-filters__list-wrapper .wp-block-byggma-brann-og-lyd-product-filters__list-wrapper')
    .forEach(function (subListWrapperElement: HTMLDivElement) {
      const subListElement: HTMLUListElement | null = subListWrapperElement.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__list');

      const subListSizeChange = () => {
        if (subListWrapperElement && subListElement && subListElement.offsetHeight) {
          subListWrapperElement.style.setProperty('--sub-list-height', subListElement.offsetHeight + 'px' );
        }
      }

      if (subListElement) {
        new ResizeObserver(subListSizeChange).observe(subListElement)
      }
    });

  const formSizeChange = () => {
    if (formWrapperElement && formElement && formElement.offsetHeight) {
      formWrapperElement.style.setProperty('--filter-form-height', formElement.offsetHeight + 'px' );
    }
	}

  if (formElement) {
    new ResizeObserver(formSizeChange).observe(formElement)
  }

  document.body.addEventListener('click', function (event) {
    const target: HTMLElement | HTMLAnchorElement = event.target as HTMLElement

    if (
      togglefiltersButtonLink
      && (
        target.classList.contains('wp-block-byggma-brann-og-lyd-product-filters__toggle-filters-button')
        || togglefiltersButtonLink.contains(event.target as Node)
      )
    ) {
      event.preventDefault();

      const isOpen = togglefiltersButtonLink.classList.contains('open');

      if (isOpen) {
        togglefiltersButtonLink.classList.remove('open');
        if (formElement) {
          formElement.classList.remove('open');
        }
        if (formWrapperElement) {
          formWrapperElement.classList.remove('open');
        }
      } else {
        togglefiltersButtonLink.classList.add('open');
        if (formElement) {
          formElement.classList.add('open');
        }
        if (formWrapperElement) {
          formWrapperElement.classList.add('open');
        }
      }

      return;
    }

    if (! (target as HTMLAnchorElement)?.href) {
      return;
    }

    if (! productContainer || ! productContainer.contains(event.target as Node)) {
      return;
    }

    if (
      ! target.classList.contains('page-numbers')
      && ! target.classList.contains('wp-block-query-pagination-next')
      && ! target.classList.contains('wp-block-query-pagination-previous')
    ) {
      return;
    }

    event.preventDefault();

    reloadProductsWithUrl((target as HTMLAnchorElement)?.href, true);
  });

  const maybeDeselectChildren = function(input: HTMLInputElement) {
    if (input.checked) {
      return;
    }

    const formSubCheckInputs: NodeListOf<HTMLInputElement> | undefined = input.nextElementSibling?.nextElementSibling?.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters__form-check-input');

    if (!formSubCheckInputs) {
      return;
    }

    formSubCheckInputs.forEach(function(formSubCheckInput) {
      formSubCheckInput.checked = false;
    });
  }

  const evaluateSelectorShow = function(input: HTMLInputElement) {
    const selectorShow = input.dataset.selectorShow;

    if (!selectorShow) {
      return;
    }

    const elementsToShowOrHide: NodeListOf<HTMLElement> = block.querySelectorAll(selectorShow);

    elementsToShowOrHide.forEach((element) => {
      element.style.display = input.checked ? 'block' : 'none';

      if (!input.checked) {
        const formSubCheckInputs: NodeListOf<HTMLInputElement> = element.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters__form-check-input');

        if (!formSubCheckInputs) {
          return;
        }

        formSubCheckInputs.forEach(function(formSubCheckInput) {
          formSubCheckInput.checked = false;
        });
      }
    });
  }

  const reloadProducts = function() {
    if (!formElement) {
      return;
    }

    const data = new URLSearchParams();

    for (const pair of new FormData(formElement)) {
      data.append(pair[0], '' + pair[1]);
    }

    const formElementAction = formElement.action.replace(/\/$/gm,'') + '/';
    const url = data.size > 0 ? formElementAction + '?' + data : formElementAction;

    reloadProductsWithUrl(url);
  }

  const debouncedReloadProducts = debounce(reloadProducts, 350, { 'maxWait': 3000 });

  const onChange = function(event: any) {
    if (!event?.target) {
      return;
    }

    const input: HTMLInputElement = event.target

    maybeDeselectChildren(input);
    evaluateSelectorShow(input);

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    debouncedReloadProducts();
  }

  formCheckInputs.forEach(function(formCheckInput) {
    formCheckInput.addEventListener('change', onChange)
  })

  formCheckInputs.forEach(function(formCheckInput) {
    evaluateSelectorShow(formCheckInput)
  })
}
